import * as types from '../mutation-types'
import core from '@/js/core/core'
import vueCookie from 'vue-cookie'

// initial state
const state = {
   dateList : {},
   leagueList: {},
   scoreList:{},
   plytyp:{},
   nowts: 0,
   resultDate:0,
   resultSport:'N1',
}

// getters
const getters = {
    dateList: state => state.dateList,
    leagueList: state => state.leagueList,
    scoreList: state => state.scoreList,
    plytyp: state => state.plytyp,
    nowts: state => state.nowts,    
    resultDate: state => state.resultDate,  
    resultSport: state => state.resultSport   
}
// actions
const actions = {
    getDate(context, payload){
        core.$ajax({
            method: 'get',
            url: payload.url,
            data:{token: payload.token}
          }).done(((res)=> {
            this.commit('DATE_LIST', res.data)
          }).bind(this)).catch((errRes)=> {
            console.log(errRes)
          })
    },

    getLeagueList(context,payload){
        var data = {}
        data.date = payload.date
        data.sportId = payload.sportId
        data.langId = window._langid
        data.token = payload.token
        data.resultType = payload.resultType
        core.$ajax({
            method: 'get',
            url: payload.url,
            data: data
          }).done(((res)=> {
            this.commit('LEAGUE_LIST',res.leagueList)
          }).bind(this)).catch((errRes)=> {
            console.log(errRes)
          })
    },

    getScore(context,payload){
        var data = {}
        data.date = payload.date
        data.sportId = payload.sportId
        data.langId = window._langid
        data.token = payload.token
        data.resultType = payload.resultType
        data.lgeid = payload.lgeid
        data.enableLoading = false
        core.$ajax({
            method: 'get',
            url: payload.url,
            data: data
          }).done(((res)=> {
            this.commit('SCORE_LIST',res.data)
            this.commit('PLY_TYPE',res.plyTyp)
            this.commit('NOW_TS',res.now)
          }).bind(this)).catch((errRes)=> {
            console.log(errRes)
          })
    }
    
    
}

// mutations
const mutations = {
    DATE_LIST(state, payload){
        state.dateList = payload
    },
    LEAGUE_LIST(state,payload){
        state.leagueList = payload
    },
    SCORE_LIST(state,payload){
        state.scoreList = payload
    },
    PLY_TYPE(state,payload){
        state.plytyp = payload
    },
    NOW_TS(state,payload){
        state.nowts = payload
    },
    RESULT_SPORT(state,payload){
      state.resultSport = payload
    },
    RESULT_DATE(state,payload){
        state.resultDate = payload
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/result.js